import React from "react";
import { CheckCircle2, HeartHandshake, Sparkles } from "lucide-react";
import Reveal from "../Reveal";
import fotoSobre from "../../assets/sobre/7.jpeg";

const highlights = [
  { icon: HeartHandshake, title: "Atendimento humanizado", desc: "Cada pet é único — tratamos com paciência, carinho e atenção total." },
  { icon: Sparkles, title: "Profissionais especializados", desc: "Equipe treinada em bem-estar animal, banho e tosa." },
  { icon: CheckCircle2, title: "Estrutura moderna", desc: "Ambiente higienizado, seguro e equipado para o conforto do seu pet." },
];

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative overflow-hidden py-24 sm:py-32 text-white bg-transparent"
    >
      <div className="absolute inset-0 paw-tile opacity-10 pointer-events-none" />

      <div className="container-pad grid lg:grid-cols-12 gap-12 lg:gap-20 items-center relative z-10">
        <Reveal as="div" className="lg:col-span-5 relative">
          <div className="absolute -top-4 -left-4 w-24 h-24 rounded-3xl bg-gold/30 blur-sm" />
          <div className="absolute -bottom-4 -right-4 w-32 h-32 rounded-full bg-white/15 blur-md" />

          <div className="relative rounded-[36px] overflow-hidden border border-white/15 bg-white/10 backdrop-blur-xl shadow-[0_35px_100px_rgba(0,0,0,0.35)]">
            <img
              src={fotoSobre}
              alt="Tia Sandra Pet Care"
              className="w-full h-[520px] object-cover opacity-95 hover:scale-105 transition-transform duration-[1200ms]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-royal/35 via-transparent to-transparent" />
          </div>
          
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal as="div" className="inline-block px-4 py-1.5 rounded-full bg-white/12 backdrop-blur-xl border border-white/15 text-white text-xs font-bold uppercase tracking-[0.18em] mb-5">
            Sobre nós
          </Reveal>

          <Reveal as="h2" delay={80} className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]">
            Um lugar feito com <span className="italic text-gold">amor</span> para quem trata pet como família.
          </Reveal>

          <Reveal as="p" delay={160} className="mt-6 text-base sm:text-lg text-white/80 leading-relaxed">
            A <strong className="text-white">Tia Sandra Pet Care</strong> nasceu do desejo de oferecer um atendimento diferenciado, onde cada pet é tratado com o respeito e o carinho que merece. Aqui, profissionalismo encontra acolhimento — e cada visita é uma experiência tranquila, divertida e segura.
          </Reveal>

          <Reveal as="p" delay={220} className="mt-4 text-base text-white/75 leading-relaxed">
            Nossa missão é cuidar do bem-estar físico e emocional do seu melhor amigo, do primeiro banho ao cuidado de rotina.
          </Reveal>

          <div className="mt-10 grid sm:grid-cols-3 gap-5">
            {highlights.map((h, i) => (
              <Reveal
                key={h.title}
                delay={260 + i * 80}
                className="group p-5 rounded-3xl bg-white/10 backdrop-blur-xl border border-white/15 hover:bg-white/16 hover:-translate-y-1 hover:shadow-[0_25px_70px_rgba(0,0,0,0.25)] transition-all"
              >
                <div className="w-11 h-11 rounded-2xl bg-gold text-royal flex items-center justify-center mb-3 group-hover:scale-110 group-hover:rotate-[-6deg] transition-transform">
                  <h.icon className="w-5 h-5" />
                </div>
                <h3 className="font-heading text-lg text-white font-semibold mb-1">{h.title}</h3>
                <p className="text-sm text-white/70 leading-relaxed">{h.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
